import { render, staticRenderFns } from "./SideNavBar.vue?vue&type=template&id=26b0e6fd&"
import script from "./SideNavBar.vue?vue&type=script&lang=js&"
export * from "./SideNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports